import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from 'src/app/services/home/home.service';

@Component({
  selector: 'app-asset-library',
  templateUrl: './asset-library.component.html',
  styleUrls: ['./asset-library.component.scss']
})
export class AssetLibraryComponent implements OnInit {
  public assetLibraries:any = [];
  public engagementId!:any;
  @Input() data: any = {
    'clientId': '',
    'isModal':false
  };
  constructor(private router:Router,private route: ActivatedRoute, private homeServiceRef: HomeService) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.engagementId = id || this.data.clientId;
    console.log(this.engagementId);          
    // this.homeServiceRef.getAssetLibraryData().subscribe((data: any[]) => {
      // this.assetLibraries = data;
      this.homeServiceRef.getAssetLibraryData(this.engagementId).subscribe((data: any[]) => {
      this.assetLibraries = data.filter(a=> a.isDisplayed).sort((a,b)=> a.order - b.order);
    });    
  }

  goHome()
  {
    this.router.navigate([`/home`, this.engagementId]);
  }

}
